import React, {useState, Fragment} from 'react';
import * as S from './style'
import Paper from '@material-ui/core/Paper';
import parse from 'html-react-parser';
import {TreeDataState, CustomTreeData, EditingState, RowDetailState, VirtualTableState} from '@devexpress/dx-react-grid'
import {Undo16, Edit16, Calendar16, Launch16} from '@carbon/icons-react'
import {
    Grid,
    Table,
    TableHeaderRow,
    TableTreeColumn,
    TableEditRow,
    TableFixedColumns,
    TableRowDetail,
    VirtualTable,
} from '@devexpress/dx-react-grid-material-ui'
import {TemplateConnector} from "@devexpress/dx-react-core";
import {useTableConfig} from './hooks';
import TableRow from './components/TableRow'
import {TableHeaderContent} from './components/TableHeader'
import {ComposedModal, ModalBody, ModalFooter, ModalHeader} from "carbon-components-react";
import data from "../../data";
import moment from 'moment';

const CustomTable = ({
                         headerInformation = null,
                         columns,
                         rowsData,
                         editable = false,
                         rowDetail = false,
                         editValues,
                         Headertext = "Report",
                         headerDescription = true,
                         fixedColumns = true,
                         getRemoteRows = [],
                         defaultExpandedRowIds = [],
                         totalRowCount = 0
                     }) => {
    const {
        setIsEditing,
        isEditing,
        tableColumnExtensions,
        getChildRows,
        rows,
        commitChanges,
        getRowId,
        leftColumns,
        changeColumns,
        editedRows,
        setEditedRows,
        editingRows,
        editingColumns,
        setEditingRows,
        undoChanges
    } = useTableConfig({rowsData, columns, editable, rowDetail, Headertext, getRemoteRows})

    const [modal, setModal] = useState(false);

    const RowDetail = ({row}) => (
        process.env.REACT_APP_ARMEN_THEME == 'gpa' ? (<Fragment>
            <div style={{"padding": "15px"}}>
                <strong>Creation Date:</strong> {row.creation_date} &nbsp;&nbsp;&nbsp;&nbsp;
                <strong>Fornec Pef:</strong> {row.fornec_pef} &nbsp;&nbsp;&nbsp;&nbsp;<br/>
                <strong>Cod Categ:</strong> {row.cod_categ} &nbsp;&nbsp;&nbsp;&nbsp;
                <strong>Nom Categ:</strong> {row.nom_categ} &nbsp;&nbsp;&nbsp;&nbsp;
                <strong>Cod Sub categ:</strong> {row.cod_subcateg} &nbsp;&nbsp;&nbsp;&nbsp;
                <strong>Nom Sub categ:</strong> {row.nom_subcateg} &nbsp;&nbsp;&nbsp;&nbsp;<br/>

                <strong>Cod Fornec:</strong> {row.cod_fornec} &nbsp;&nbsp;&nbsp;&nbsp;
                <strong>Nom Fornec:</strong> {row.nom_fornec} &nbsp;&nbsp;&nbsp;&nbsp;
                <strong>Gecon:</strong> {row.gecon} &nbsp;&nbsp;&nbsp;&nbsp;
                <strong>Nom Gecon:</strong> {row.nome_gecon} &nbsp;&nbsp;&nbsp;&nbsp;<br/>

                <strong>Cod Depto:</strong> {row.cod_depto} &nbsp;&nbsp;&nbsp;&nbsp;
                <strong>Nom Depto:</strong> {row.nom_depto} &nbsp;&nbsp;&nbsp;&nbsp;
                <strong>Regional:</strong> {row.regional} &nbsp;&nbsp;&nbsp;&nbsp;<br/>


                <strong>Nom Mes:</strong> {row.nom_mes} &nbsp;&nbsp;&nbsp;&nbsp;
                <strong>Ano:</strong> {row.ano} &nbsp;&nbsp;&nbsp;&nbsp;<br/>

                <strong>Val Venda Liquida:</strong> {row.val_venda_liquida} &nbsp;&nbsp;&nbsp;&nbsp;<br/>
            </div>
        </Fragment>) : process.env.REACT_APP_ARMEN_THEME == 'credz' ? (
            <Fragment>
                <div style={{"padding": "15px"}}>
                    <strong>Score:</strong> {parseFloat(row.score).toFixed(2)}<br/>
                    <strong>Texto:</strong> {parse(row.text)}<br/>
                    <strong>Tópicos:</strong> {row.bigram_cliente.slice(0, -1) + " , " + row.bigram_telefonista.slice(1)}
                </div>
            </Fragment>) : process.env.REACT_APP_ARMEN_THEME == 'afinz' ? (
            <Fragment>
                <div style={{"padding": "15px"}}>

                    <strong>Id
                        cliente:</strong> {row.idcliente.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, "$1-$2-$3-$4")}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Id cliente migrado FISERV:</strong> {!row.idcliente_fiserv ? "---" : row.idcliente_fiserv}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Destinatário:</strong> {row.destinatario}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Telefone:</strong> {row.telefone}&nbsp;&nbsp;&nbsp;&nbsp;<br/>

                    <strong>Status:</strong> {row.status}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Courier:</strong> {row.courier}&nbsp;&nbsp;&nbsp;&nbsp;<br/>
                    <strong>Correios:</strong> {row.correios == true ? 'Sim' : 'Não'}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Código correios:</strong> {row.cod_correios === "" ? ' --- ' : <>{row.cod_correios} <a href="https://rastreamento.correios.com.br/app/index.php" target={"_blank"}><Launch16 size="small"/></a></> }<br/>

                    <strong>Cep:</strong> {row.cep}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Endereço:</strong> {row.endereco}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Cidade:</strong> {row.cidade_destino}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>UF:</strong> {row.uf_destino}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Região:</strong> {row.regiao}<br/>

                    <strong>Data coleta:</strong> {moment(row.data_coletado).format('DD/MM/YYYY HH:mm')}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Data status:</strong> {moment(row.data_status).format('DD/MM/YYYY HH:mm')}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Previsão entrega:</strong> {moment(row.previsao_prazo_data).format('DD/MM/YYYY')}<br/>
                    <strong>Informação adicional:</strong> {row.informacao_adicional === "" ? "---" : row.informacao_adicional}<br/>
                </div>
            </Fragment>) : process.env.REACT_APP_ARMEN_THEME == 'cupcakevox' ? (
            <Fragment>
                <div style={{"padding": "15px"}}>
                    <strong>Score:</strong> {(row.score).toFixed(2)}<br/>
                    <strong>Nome produto:</strong> {row.nome_produto}<br/>
                    <strong>Nota (1 a 5):</strong> {row.nota} &nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Produto recomendado:</strong> {row.recomenda_produto}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Sentimento:</strong> {row.sentiment}&nbsp;&nbsp;&nbsp;&nbsp;<br/>
                    <strong>Comentário:</strong> {row.comentario}&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
            </Fragment>
        ) : process.env.REACT_APP_ARMEN_THEME == 'ccr' ? (
            <Fragment>
                <div style={{"padding": "15px"}}>
                    <strong>Data:</strong> {moment(row.data).format('DD/MM/YYYY')}<br/>

                    <strong>km_inicial:</strong> {row.km_inicial}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>km_final:</strong> {row.km_final}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>sentido:</strong> {row.sentido}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>faixa:</strong> {row.faixa}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>extensao_m:</strong> {row.extensao_m}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>largura_m:</strong> {row.largura_m}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>espessura_m_1:</strong> {row.espessura_m_1}<br/>

                    <strong>material:</strong> {row.material}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>cap:</strong> {row.cap}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>usina:</strong> {row.usina}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>certificado_no:</strong> {row.certificado_no}<br/>

                    <strong>temperatura_ambiente:</strong> {row.temperatura_ambiente}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>temperatura_saida_usina:</strong> {row.temperatura_saida_usina}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>temperatura_chegada_obra:</strong> {row.temperatura_chegada_obra}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>temperatura_lancamento:</strong> {row.temperatura_lancamento}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>temperatura_descarga:</strong> {row.temperatura_descarga}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>temperatura_compactacao:</strong> {row.temperatura_compactacao}<br/>

                    <strong>perc_grau_de_compact:</strong> {row.perc_grau_de_compact}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>perc_teor_de_vazios:</strong> {row.perc_teor_de_vazios}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>teor_de_cap:</strong> {row.teor_de_cap}<br/>

                </div>
            </Fragment>
        ) : (
            <Fragment>
                <div style={{"padding": "15px"}}>
                    <strong>Score:</strong> {(row.score).toFixed(2)}<br/>
                    <strong>Id produto:</strong> {row.id_produto} &nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Nome produto:</strong> {row.nome_produto}<br/>
                    <strong>Nota (1 a 5):</strong> {row.nota} &nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Produto recomendado:</strong> {row.recomenda_produto}&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Sentimento:</strong> {row.sentiment}&nbsp;&nbsp;&nbsp;&nbsp;<br/>
                    <strong>Comentário:</strong> {row.comentario}&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
            </Fragment>
        )
    );
    return (

        <>
            <ComposedModal size="xs" open={modal}>
                <ModalHeader title="Alert"/>
                <ModalBody>
                    Editing saved successfully
                </ModalBody>
                <ModalFooter onRequestSubmit={() => {
                    setModal(false)
                }} primaryButtonText="Close"></ModalFooter>
            </ComposedModal>

            <S.Container>
                {
                    headerInformation && (
                        <S.HeaderWrapper>
                            <S.HeaderTitle>{Headertext}</S.HeaderTitle>
                            {headerDescription && (
                                <S.DescriptionWrapper>
                                    <Calendar16/>
                                    {headerInformation.dateBetween &&
                                        <S.DescriptionLabel>{headerInformation.dateBetween}</S.DescriptionLabel>} /
                                    {headerInformation.Country &&
                                        <S.DescriptionLabel>Country: {headerInformation.Country}</S.DescriptionLabel>} /
                                    {headerInformation.FunctionalArea && <S.DescriptionLabel>Functional
                                        Area: {headerInformation.FunctionalArea}</S.DescriptionLabel>} /
                                    {headerInformation.PersonResponsible && <S.DescriptionLabel>Person
                                        Responsible: {headerInformation.PersonResponsible}</S.DescriptionLabel>} /
                                    {headerInformation.UserResponsible && <S.DescriptionLabel>User
                                        Responsible: {headerInformation.UserResponsible}</S.DescriptionLabel>} /
                                    {headerInformation.CostCenter &&
                                        <S.DescriptionLabel>Cost
                                            Center: {headerInformation.CostCenter}</S.DescriptionLabel>}
                                </S.DescriptionWrapper>
                            )}
                        </S.HeaderWrapper>
                    )
                }

                <Paper>
                    <Grid
                        rows={rows}
                        columns={columns}
                        getRowId={getRowId}>
                        <TreeDataState/>
                        <RowDetailState
                            defaultExpandedRowIds={defaultExpandedRowIds}
                        />

                        <CustomTreeData getChildRows={getChildRows}/>
                        <EditingState
                            rowChanges={editedRows}
                            onRowChangesChange={setEditedRows}
                            onEditingRowIdsChange={setEditingRows}
                            editingRowIds={isEditing ? editingRows : []}
                            columnExtensions={editingColumns}
                            onCommitChanges={commitChanges}
                            onEditingCellsChange={(e) => console.log(e)}
                        />
                        <Table columnExtensions={tableColumnExtensions} rowComponent={TableRow}/>
                        <VirtualTable
                            height="600px"
                        />
                        <VirtualTable columnExtensions={tableColumnExtensions}/>

                        <TableHeaderRow
                            contentComponent={(e) => TableHeaderContent(e, changeColumns, leftColumns, editValues, fixedColumns)}/>
                        {rowDetail && (
                            <TableRowDetail
                                contentComponent={RowDetail}
                            />
                        )}
                        {!rowDetail && (
                            <TableEditRow/>
                        )}
                        <TableTreeColumn for={columns[0].name}/>
                        <TableFixedColumns leftColumns={leftColumns}/>
                        {editable && (
                            <S.ButtonWrapper>
                                <S.ButtonContainer onClick={() => undoChanges()}><Undo16/></S.ButtonContainer>
                                <S.ButtonContainer
                                    onClick={() => setIsEditing(!isEditing)}><Edit16/></S.ButtonContainer>
                                <TemplateConnector>
                                    {(getters, {commitChangedRows}) => (
                                        <S.ButtonContainer onClick={() => {
                                            if (isEditing) {
                                                setIsEditing(!isEditing)
                                            }
                                            commitChangedRows({rowIds: editingRows});
                                            setModal(true);
                                        }
                                        }
                                                           saveButton>Save</S.ButtonContainer>
                                    )}
                                </TemplateConnector>
                            </S.ButtonWrapper>
                        )}

                    </Grid>
                </Paper>
            </S.Container>
        </>
    )
};

export default CustomTable
